import React from "react";
import { ComponentType, isValidElement, ReactElement } from "react";
import { Route, Routes } from "react-router-dom";
import { useRouteParams } from "../Hooks/Params/useRouteParams";
import { PrivateRoute } from "../Routes";
import { ResourceContextProvider } from "./ResourceContextProvider";

export type ResourceType = {
  path: string;
  main?: ComponentType<any> | ReactElement;
  detail?: ComponentType<any> | ReactElement;
  permissions?: string[];
};

const createElement = (
  Element: ComponentType<any> | ReactElement,
  permissions?: string[],
  props?: any
) =>
  permissions ? (
    <PrivateRoute
      permissions={permissions}
      element={isValidElement(Element) ? Element : <Element {...props} />}
    />
  ) : isValidElement(Element) ? (
    Element
  ) : (
    <Element {...props} />
  );

export const Resource = (props: ResourceType) => {
  const { main: List, detail: Detail, permissions, path } = props;

  const params = useRouteParams(path, window.location.pathname);

  return (
    <ResourceContextProvider value={path}>
      <Routes>
        {List && (
          <Route
            path={"/*"}
            element={createElement(List, permissions, {
              path: path,
              currentPath: window.location.pathname,
              params: params,
            })}
          >
            {Detail && (
              <>
                <Route
                  path={"create/*"}
                  element={createElement(Detail, permissions, {
                    path,
                    mode: "CREATE",
                  })}
                />
                <Route
                  path={":id/*"}
                  element={createElement(Detail, permissions, {
                    path,
                    mode: "EDIT",
                  })}
                />
                <Route
                  path={":id/show/*"}
                  element={createElement(Detail, permissions, {
                    path,
                    mode: "SHOW",
                  })}
                />
              </>
            )}
          </Route>
        )}
      </Routes>
    </ResourceContextProvider>
  );
};
